import { TranslateService } from '@ngx-translate/core';
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { SpinnerService } from 'shared-components';
import { CultivosService } from '../../../services/cultivos.service';
import { SessionContextService } from 'projects/packcert-web/src/app/context/session-context.service';

@Component ({
    selector: 'app-designacion-finca',
    templateUrl: './designacion-finca.component.html'
})
export class DesignacionFincaComponent implements OnInit {

    private readonly _DEFAULT_ITEMS_PER_PAGE = 10;

    public listaDesignacionesFinca;

    public editables;
    public new = false;

    public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
    public currentPage = 0; // La paginacion en back empieza por 0
    public totalItems: number;
    public readonly visiblePages = 3;

    public orderBy: string;
    public firtstime = true;
    public idColumn;

    public blockchainInfo: number;

    @Input() fincaId;
    @Input() filtersCultivo;

    @Output() pushMessage = new EventEmitter<string>();

    constructor(
        private readonly _spinnerService: SpinnerService,
        private readonly _cultivoService: CultivosService,
        private readonly _translate: TranslateService,
        private readonly _sessionContext: SessionContextService
    ) {}

    ngOnInit() {
        this.getDesignacionesFinca();
    }

    public get defaultLanguage() {
      return this._translate.getDefaultLang();
    }

    public get claims() {
        return this._sessionContext.sessionUser.lsClaimTypes;
    }

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public pageChange(page) {
        this.currentPage = page - 1;
        this.getDesignacionesFinca();
    }

    public itemsPerPageChange(items) {
        this.currentPage = 0;
        this.itemsPerPage = items;
        this.getDesignacionesFinca();
    }

    public getDesignacionesFinca() {
        this._spinnerService.showSpinner();
        if(!this.filtersCultivo) this.filtersCultivo = {};
        this.filtersCultivo.fincaId = this.fincaId;
        this.filtersCultivo.cargaRegBlockchain = true;
        this._cultivoService.getCultivosYDesignacionesFincaByFilters(this.filtersCultivo).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.listaDesignacionesFinca = resp.designacionesAccesibles;
        });
    }

    public editableChanged(designacionFinca) {
        this.editables = designacionFinca;
        this.new = false;
    }

    public refresh(value) {
        this.editables = '';
        if (value) {
            this.reload();
        }
    }

    public reload() {
        this.getDesignacionesFinca();
    }

    public toOrderBy(id: any) {
      this.idColumn = id;
      if (this.firtstime) {
          this.orderBy = 'desc';
          this.firtstime = false;
      } else {
          if (this.orderBy === 'desc') {
              this.orderBy = 'asc';
          } else if (this.orderBy === 'asc') {
              this.orderBy = 'desc';
          }
      }
    }

    public getIcon(id: any) {
      let iconClass = 'fa fa-sort';
      if (id === this.idColumn) {
          iconClass = this.orderBy === 'desc' ? 'fa fa-sort-down' : 'fa fa-sort-up';
      }
      return iconClass;
    }

    public showMoreInfo(index: number) {
        this.blockchainInfo = this.blockchainInfo === index ? -1 : index;
    }
}
